module.exports = __webpack_public_path__ + "img/2.8ee16fb4.png";